/**
 * Real-time Footer Statistics Updater
 * Updates visit counts every 30 seconds via AJAX
 */
(function() {
    'use strict';

    const STATS_API_URL = '/api/stats';
    const UPDATE_INTERVAL = 30000; // 30 seconds

    /**
     * Fetch and update statistics
     */
    function updateStats() {
        fetch(STATS_API_URL)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data.success && data.data) {
                    updateStatsUI(data.data);
                }
            })
            .catch(error => {
                console.error('Error fetching stats:', error);
            });
    }

    /**
     * Update UI with new statistics
     */
    function updateStatsUI(stats) {
        // Update total visits
        const totalElement = document.getElementById('stat-total-visits');
        if (totalElement) {
            animateNumber(totalElement, stats.total_visits);
        }

        // Update today's visits
        const todayElement = document.getElementById('stat-today-visits');
        if (todayElement) {
            animateNumber(todayElement, stats.today_visits);
        }

        // Update active users
        const activeElement = document.getElementById('stat-active-users');
        if (activeElement) {
            animateNumber(activeElement, stats.active_users);
        }
    }

    /**
     * Animate number change
     */
    function animateNumber(element, newValue) {
        const currentText = element.textContent.replace(/,/g, '');
        const currentValue = parseInt(currentText) || 0;

        if (currentValue === newValue) {
            return; // No change
        }

        // Add highlight animation
        element.style.transition = 'color 0.3s ease';
        element.style.color = '#C85248'; // Highlight color

        // Update the number with formatting
        element.textContent = newValue.toLocaleString();

        // Remove highlight after animation
        setTimeout(() => {
            element.style.color = '';
        }, 500);
    }

    /**
     * Initialize real-time updates
     */
    function init() {
        // Update immediately on load
        updateStats();

        // Set interval for periodic updates
        setInterval(updateStats, UPDATE_INTERVAL);
    }

    // Start updates when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
